var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonIconSave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 4.22222V16.8889C18.5 17.4694 18.3043 17.9666 17.913 18.3804C17.5217 18.7942 17.0507 19.0007 16.5 19H2.5C1.95 19 1.47933 18.7935 1.088 18.3804C0.696667 17.9673 0.500667 17.4701 0.5 16.8889V2.11111C0.5 1.53056 0.696 1.03374 1.088 0.620667C1.48 0.207593 1.95067 0.000703704 2.5 0H14.5L18.5 4.22222ZM16.5 5.11944L13.65 2.11111H2.5V16.8889H16.5V5.11944ZM9.5 15.8333C10.3333 15.8333 11.0417 15.5255 11.625 14.9097C12.2083 14.294 12.5 13.5463 12.5 12.6667C12.5 11.787 12.2083 11.0394 11.625 10.4236C11.0417 9.80787 10.3333 9.5 9.5 9.5C8.66667 9.5 7.95833 9.80787 7.375 10.4236C6.79167 11.0394 6.5 11.787 6.5 12.6667C6.5 13.5463 6.79167 14.294 7.375 14.9097C7.95833 15.5255 8.66667 15.8333 9.5 15.8333ZM3.5 7.38889H12.5V3.16667H3.5V7.38889ZM2.5 5.11944V16.8889V2.11111V5.11944Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIconSave);
export default __webpack_public_path__ + "static/media/buttonIconSave.47c9b03e807afca00386b9d79f58dc9d.svg";
export { ForwardRef as ReactComponent };